export default __webpack_public_path__ + "static/media/timeWarp.c7b2df62.png";